import { Lens } from 'monocle-ts';

import {
	type ConvoAIStreamingConfig,
	type UserConvoAIStreamingConfig,
} from '../../models/ConvoAIStreamingConfig';
import { BASE_STREAM_URL } from './convoAIConstants';
import { type ConvoAIStreamingHeaders } from './ConvoAIStreamingModels';

const baseUrl = Lens.fromNullableProp<UserConvoAIStreamingConfig>()('baseUrl', BASE_STREAM_URL);
const enablePartialJson = Lens.fromNullableProp<UserConvoAIStreamingConfig>()(
	'enablePartialJson',
	false,
);
const enableFollowUp = Lens.fromNullableProp<UserConvoAIStreamingConfig>()('enableFollowUp', false);
const enableLocalVerboseLogs = Lens.fromNullableProp<UserConvoAIStreamingConfig>()(
	'enableLocalVerboseLogs',
	false,
);
const enableTraceMessage = Lens.fromNullableProp<UserConvoAIStreamingConfig>()(
	'enableTraceMessage',
	false,
);
const skip = Lens.fromNullableProp<UserConvoAIStreamingConfig>()('skip', false);

const contentType = Lens.fromNullableProp<ConvoAIStreamingHeaders>()(
	'content-type',
	'application/json;charset=UTF-8',
);

const xIssyntheticTraffic = Lens.fromNullableProp<ConvoAIStreamingHeaders>()(
	'x-issynthetic-traffic',
	'false',
);

function getHeaders(
	config: Pick<ConvoAIStreamingConfig, 'headers' | 'apiPath'> & Partial<ConvoAIStreamingConfig>,
) {
	const headers: ConvoAIStreamingHeaders = {
		'content-type': contentType.get(config.headers),
		'x-product': config.headers['x-product'],
		'x-experience-id': config.headers['x-experience-id'],
		'x-issynthetic-traffic': xIssyntheticTraffic.get(config.headers),
	};

	if (config.headers['x-channel-id']) {
		headers['x-channel-id'] = config.headers['x-channel-id'];
	}

	return headers;
}

export const getDefaultConvoAIConfigWithUserSettings = (
	config: UserConvoAIStreamingConfig,
): ConvoAIStreamingConfig => ({
	baseUrl: baseUrl.get(config),
	apiPath: config.apiPath,
	enablePartialJson: enablePartialJson.get(config),
	enableFollowUp: enableFollowUp.get(config),
	enableTraceMessage: enableTraceMessage.get(config),
	enableLocalVerboseLogs: enableLocalVerboseLogs.get(config),
	timeoutDelay: config.timeoutDelay,
	skip: skip.get(config),
	headers: getHeaders(config),
});
